module.exports = __webpack_public_path__ + "img/appointment_new.c8c20d4e.png";